import React from "react"
// eslint-disable-next-line no-restricted-imports -- FIXME: Usages of styled-components should be replaced with components from carotene-core or carotene-core-x. Please do not import styled-components after eslint rule added on 3/21/2025.
import styled from "styled-components"
import { VectorMap } from "@south-paw/react-vector-maps"
import { useQuery } from "@tanstack/react-query"
import { Box, Progress } from "@carrotfertility/carotene-core"

const MapDiv = styled.div`
  background: #f7f9fa;
  border-radius: 8px;
  margin-block-end: 10px;
  padding: 10px;

  svg {
    stroke: #ffffff;
    stroke-width: 1px;
    cursor: pointer;

    path {
      fill: #d3dfe3;

      &[aria-checked="true"] {
        fill: #e48400;
        stroke: #e48400;
        stroke-width: 1px;
      }

      &[aria-current="true"] {
        fill: #fae6cc;
        stroke: #fae6cc;
        stroke-width: 1px;
      }

      &:focus {
        outline: none;
      }
    }
  }
`

type WorldVectorMapProps = {
  selectedLocationId: string
  hoveredLocationId: string
  // @ts-expect-error TS(7006) FIXME: Parameter 'layer' implicitly has an 'any' type.
  onMouseEnter?: (layer) => void
  // @ts-expect-error TS(7006) FIXME: Parameter 'layer' implicitly has an 'any' type.
  onClick?: (layer) => void
  // @ts-expect-error TS(7006) FIXME: Parameter 'layer' implicitly has an 'any' type.
  onMouseLeave?: (layer) => void
}

const WorldVectorMap = ({
  selectedLocationId,
  hoveredLocationId,
  onMouseEnter = null,
  onClick = null,
  onMouseLeave = null
}: WorldVectorMapProps): JSX.Element => {
  const worldMapDataQuery = useQuery(
    ["worldData"],
    async () => import(/* webpackChunkName: "worldVectorMapData" */ "./WorldVectorMap.json")
  )

  return (
    <MapDiv>
      {worldMapDataQuery.isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Progress />
        </Box>
      ) : (
        <VectorMap
          tabIndex={-1}
          {...worldMapDataQuery.data}
          checkedLayers={[selectedLocationId]}
          currentLayers={[hoveredLocationId]}
          layerProps={{ onMouseEnter, onMouseLeave, onClick }}
        />
      )}
    </MapDiv>
  )
}

export default WorldVectorMap
